/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { PageHeader } from '../../company-profile/profile.styled';
import Heading from '../../../../components/typography';
import { COLORS } from '../../../../constants/style/color';
import Search from '../../../../components/search/search';
import { type ModalStatusType, type TableParamsType } from '../../../../types/common';
import InitialValuesForm from '../../../../constants/initialValues';
import { ImportBlock, ResetFilterWrapper } from '../../../../constants/style/common.styled';
import { SettingSystemUserButton } from '../../system-users/systemUserStyled';
import Button from '../../../../components/button';
import {
  useAdvanceBoolean,
  useBoolean,
  useGetIncomeYtdTypes,
  useGetTablePreferences,
  useGetTaxApprovalStatusList,
  // useGetOverrideTaxData,
  useGetTaxPeriodAll,
  useGetTaxSetupList,
  usePostTablePreferences,
} from '../../../../hooks';
import FormSelect from '../../../../components/dropdown/formSelect';
import Table from '../../../../components/table';
import AnimationWrapper from '../../../../components/animation/animationWrapper';
import TaxSetupModal from './taxSetupModal';
import useWealthlaneTaxApi from '../../../../hooks/useWealthlaneTaxApi';
import TaxOverrideModal from './taxOverrideModal';
import RequestModal from './requestModal';
import {
  TaxCalculationService,
  TaxItemApprovalService,
  TaxItemImportService,
  TaxItemService,
  Wealthlane_TaxService_Dtos_ParticipantTransaction_TaxCalculationUsingImportDto,
  type Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemDto,
} from '../../../../services/wealthlane-tax-services';
import { toast } from 'react-toastify';
import ToastComponent from '../../../../components/toast';
import { MutationCache, useMutation, useQueryClient } from 'react-query';
import useGetTaxSetupViewByTaxId from '../../../../hooks/get/useGetTaxSetupViewByTaxId';
import { TaxSetupHeader } from '../../../../constants/table-headers/taxSetupHeader';
import TaxImportModal from './taxImportModal';
import { isEmpty } from 'lodash';
import usePostTaxCalculationImport from '../../../../hooks/post/usePostTaxCalculationImport';
import Filter from '../../../../components/filter';
import { PlainTextWrapper } from '../../system-roles/roles.styled';
import { ActionButton } from '../../../../components/vertical-dot/popper';
import { handleOpenFile } from '../../../../utils/global';
import Spinners from '../../../../components/spinner';
import { InputField } from '../../../participants/participant.styled';
// import useDynamicTable from '../../../../packages/table-builder/hooks/useDynamicTable';
// import useTableSchemaLoader from '../../../../packages/table-builder/hooks/useTableSchemaLoader';
// import DynamicTable from '../../../../packages/table-builder';
// import { withDynamicTableContext } from '../../../../packages/table-builder/HOC/withDynamicTableContext';
import {
  DynamicTable,
  withDynamicTableContext,
  useDynamicTable,
  useTableSchemaLoader,
} from '@wealthlane/table-builder';
import { axiosInstance } from '../../../../services/apiInterceptor';

const TaxSetup = (): JSX.Element => {
  const queryClient = useQueryClient();
  const { handleRequest, error: apiError } = useWealthlaneTaxApi();

  // const [tableInfo, setTableInfo] = useState<TableParamsType>(InitialValuesForm.tableParams);
  const { tableInfo, setTableInfo } = useDynamicTable();

  useEffect(() => {
    setTableInfo(InitialValuesForm.tableParams);
  }, []);

  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState<string>('');
  const [headerList, setHeaderList] = useState<string[]>([]);

  const { data: taxPeriodOption, isLoading: isTaxPeriodOptionLoading } =
    useGetTaxPeriodAll(handleRequest);
  const { data: taxStatusOptions, isLoading: isTaxStatusOptionsLoading } =
    useGetTaxApprovalStatusList(handleRequest);
  const {
    data: taxList,
    isLoading: isTaxListLoading,
    status,
  } = useGetTaxSetupList(handleRequest, tableInfo);
  const { data: incomeYtdOptions, isLoading: isIncomeYtdOptionsLoading } =
    useGetIncomeYtdTypes(handleRequest);

  const { value: isModalOpen, setFalse: closeModal, setTrue: openModal } = useBoolean(false);
  const {
    value: isOpenImport,
    setFalse: closeImport,
    setTrue: openImport,
    customValue: taxItemId,
    setCustomValue: setTaxItemId,
  } = useAdvanceBoolean(false);
  const [modalStatus, setModalStatus] = useState<ModalStatusType>('Add');
  const [dataRow, setDataRow] = useState<string>();
  const [initialValue, setInitialValue] =
    useState<Wealthlane_TaxService_Dtos_TaxItemDto_TaxItemDto | null>();
  const { schemaData, isTableSchemaLoading } = useTableSchemaLoader({
    identifier: 'TAX_ITEMS_TABLE',
    baseUrl: process.env.REACT_APP_WEALTHLANE_API_ENDPOINT,
  });
  const data = React.useMemo(() => taxList?.items || [], [taxList, isTaxListLoading]);

  const { data: tablePreferences } = useGetTablePreferences(handleRequest, 'Tax Setup');

  useEffect(() => {
    tablePreferences != null && setHeaderList([...tablePreferences]);
  }, [tablePreferences]);

  const { mutate: postTablePreference, isLoading: tablePrefLoading } =
    usePostTablePreferences(handleRequest);

  const handleSavePreference = (value: string[]): void => {
    const prefPayload = {
      tableName: 'Tax Setup',
      preferences: value,
    };
    postTablePreference(prefPayload);
  };

  const { mutate, isLoading } = useGetTaxSetupViewByTaxId(handleRequest, setInitialValue);
  const [remark, setRemark] = useState<string>();
  const [open, setOpen] = useState<boolean>(false);
  const [checkedValues, setCheckedValues] = useState<any>([]);

  const {
    value: isModalOpenOverrideTax,
    setFalse: closeModalOverrideTax,
    setTrue: openModalOverrideTax,
  } = useBoolean(false);
  const {
    value: isRequestModalOpen,
    setFalse: closeRequestModal,
    setTrue: openRequestModal,
  } = useBoolean(false);

  const [importedFile, setImportFile] = useState<any>();
  const [calculatedData, setCalculatedData] = useState<any>();
  const [importLoader, setImportLoader] = useState<boolean>(false);

  const handleDelete = (id: string): void => {
    setLoading(true);
    void handleRequest(TaxItemService.deleteApiTaxApiAppTaxItemTaxItem(id))
      .then((response) => {
        if (response != null) {
          void queryClient.invalidateQueries('getTaxSetupList');
          toast.success(<ToastComponent label='Success' message={response.message} />);
        }
      })
      .finally(() => {
        setLoading(false);
        closeRequestModal();
      });
  };
  const handleDeactivateTax = (id: string): void => {
    setLoading(true);
    void handleRequest(
      TaxItemService.postApiTaxApiAppTaxItemTaxItemDeactivateSendForApproval(remark, [id])
    )
      .then((response) => {
        if (response != null) {
          void queryClient.invalidateQueries('getTaxSetupList');
          toast.success(<ToastComponent label='Success' message={response.message} />);
        }
      })
      .finally(() => {
        setLoading(false);
        closeRequestModal();
        setRemark('');
      });
  };
  const handleActivateTax = (id: string): void => {
    setLoading(true);
    void handleRequest(
      TaxItemService.postApiTaxApiAppTaxItemTaxItemReactivateSendForApproval(remark, [id])
    )
      .then((response) => {
        if (response != null) {
          void queryClient.invalidateQueries('getTaxSetupList');
          toast.success(<ToastComponent label='Success' message={response.message} />);
        }
      })
      .finally(() => {
        setLoading(false);
        closeRequestModal();
        setRemark('');
      });
  };

  const downloadTaxTemplate = (): void => {
    handleRequest(TaxItemImportService.postApiTaxApiAppTaxItemImportDownloadTaxItemImportSample())
      .then((data: any) => {
        handleOpenFile('Tax Template.xlsx', data.content);
      })
      .catch((error: any) => {
        console.log('error', error);
      });
  };

  const exportTaxTemplate = (): void => {
    handleRequest(TaxItemImportService.postApiTaxApiAppTaxItemImportDownloadTaxItemImportSample())
      .then((data: any) => {
        handleOpenFile(`${data.name}`, data.content);
      })
      .catch((error: any) => {
        console.log('error', error);
      });
  };

  const importExcel = (event: any): void => {
    if (!isEmpty(event.target.files)) {
      // setImportLoader(true);

      const payload = {
        ImportFile: event.target.files[0],
      };
      handleRequest(TaxItemImportService.postApiTaxApiAppTaxItemImportImportTaxItem(payload as any))
        .then((data: any) => {
          if (data) {
            toast.success(<ToastComponent label='Success' message='Tax import job submitted.' />);
            queryClient.invalidateQueries('getTaxSetupList');
            // setImportLoader(false);
          }
        })
        .catch((error: any) => {
          console.log('error', error);
          // setImportLoader(false);
        });
      // .finally(() => {
      //   setImportLoader(false);
      // });

      event.target.value = null;
    }
  };

  const handleChecked = (values: string[]): void => {
    setCheckedValues(values);
  };

  const handleBulkExport = (taxItemIds: string[]): void => {
    handleRequest(
      TaxItemImportService.postApiTaxApiAppTaxItemImportExportTaxItems({
        taxItemIds,
      })
    )
      .then((data: any) => {
        if (data != null) {
          handleOpenFile(`Tax Export.xlsx`, data.content);
          setCheckedValues([]);
        }
      })
      .catch((error: any) => {
        console.log('error', error);
      });
  };

  const tableActions = [
    {
      action: 'View',
      as: 'View',
      onClick: (id: string) => {
        setModalStatus('View');
        mutate(id);
        openModal();
      },
      id: 'viewTaxSetupAction',
    },
    // {
    //   action: 'Individual Tax',
    //   onClick: (id: string) => {
    //     setTaxItemId(id);
    //     openImport();
    //   },
    // },
    {
      action: 'Edit',
      as: 'Edit',
      onClick: (id: string) => {
        setModalStatus('Edit');
        mutate(id);
        openModal();
      },
      id: 'editTaxSetupAction',
    },
    {
      action: 'Make a Copy',
      as: 'Create',
      onClick: (id: string) => {
        setModalStatus('Add');
        mutate(id);
        openModal();
      },
      id: 'makeCopyTaxSetupAction',
    },
    // {
    //   action: 'Check Scenario',
    //   onClick: async (id: string) => {
    //     setTaxItemId(id);
    //     openImport();
    //   },
    // },
    {
      action: 'Activate',
      onClick: (id: string, rowData: any) => {
        setId(id);
        setDataRow(rowData);
        openRequestModal();
        setModalStatus('Activate');
      },
      id: 'activateTaxSetupAction',
    },
    {
      action: 'Request for Approval',
      onClick: (id: string, rowData: any) => {
        setId(id);
        setDataRow(rowData);
        openRequestModal();
      },
      id: 'requestApprovalTaxSetupAction',
    },
    {
      action: 'Override Tax',
      onClick: (id: string) => {
        mutate(id);
        setModalStatus('Override');

        openModalOverrideTax();
      },
      id: 'overrideTaxSetupAction',
    },
    {
      action: 'View Comment',
      onClick: async (id: string, rowData: Record<string, string>) => {
        setModalStatus('View Remarks');
        void getRejectionRemark(id);
      },
      id: 'viewCommentTaxSetupAction',
    },
    {
      action: <div className='delete-label'>Deactivate</div>,
      onClick: (id: string) => {
        setId(id);
        setModalStatus('Deactivate');
        openRequestModal();
      },
      id: 'deactivateTaxSetupAction',
    },
    {
      action: <div className='delete-label'>Delete</div>,
      as: 'Delete',
      onClick: (id: string) => {
        setId(id);
        setModalStatus('Delete');
        openRequestModal();
      },
      id: 'deleteTaxSetupAction',
    },
  ];

  const getRejectionRemark = async (id: string): Promise<void> => {
    await handleRequest(TaxItemApprovalService.getApiTaxApiAppTaxItemApprovalRemarksByTaxItemId(id))
      .then((data: any) => {
        if (data != null) {
          setRemark(data);
          openRequestModal();
        }
      })
      .catch((error: any) => {
        console.log('error', error);
      });
  };

  const onRequest = (/* values: Record<string, any> */): void => {
    modalStatus === 'Delete'
      ? handleDelete(id)
      : modalStatus === 'Deactivate'
        ? handleDeactivateTax(id)
        : modalStatus === 'Activate'
          ? handleActivateTax(id)
          : getTaxData(id, modalStatus);
  };

  const getTaxData = (id: string, status?: string): void => {
    setLoading(true);
    handleRequest(TaxItemService.postApiTaxApiAppTaxItemSendForApproval([id]))
      .then((response: any) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message={response.message} />);
          void queryClient.invalidateQueries('getTaxSetupList');
          closeModal();
          closeRequestModal();
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        closeRequestModal();
      });
  };

  function fileImport(event: any): void {
    if (!isEmpty(event.target.files)) {
      setImportFile(event.target.files[0]);
      event.target.value = null;
      setCalculatedData(null);
    }
  }
  const {
    mutate: taxImportCalculation,
    data: calculateData,
    isLoading: fileUploadLoader,
  } = usePostTaxCalculationImport(handleRequest);

  useEffect(() => {
    calculateData !== undefined && setCalculatedData(calculateData);
  }, [calculateData]);

  useEffect(() => {
    if (isOpenImport === false) {
      document.getElementsByTagName('html')[0].style.overflow = 'unset';
    }
  }, [isOpenImport]);

  const handleSubmit = () => {
    const payload = {
      file: importedFile,
      taxItemId: taxItemId,
    };
    taxImportCalculation(payload);
  };

  const TemplateDatas = [
    {
      title: 'Download Template',
      download: downloadTaxTemplate,
    },
    {
      title: 'Import Bulk XLS',
      import: importExcel,
    },
  ];

  const renderRightToolbarButton = () => {
    return (
      <Button
        as='Create'
        variant={'primary'}
        title={'Create Tax Item'}
        icon={'add_circle_outline'}
        onClick={() => {
          setModalStatus('Add');
          openModal();
        }}
      />
    );
  };

  const tableHeaderList = TaxSetupHeader({ actions: schemaData?.columns, tableActions })
    .filter((item) => item.isSubHeader)
    .map((item) => {
      // console.log('item', item);

      return {
        label: item.Header,
        value: item.accessor,
      };
    });

  const taxsetupHeader = (): any[] => {
    return TaxSetupHeader({ actions: schemaData?.columns, tableActions }).filter(
      (item) => item.isSubHeader === false || headerList.includes(item.accessor)
    );
  };

  const schema = React.useMemo(
    () => ({
      columns: taxsetupHeader(),
      options: schemaData?.options as any,
    }),
    [schemaData]
  );

  if (isTableSchemaLoading) return <Spinners containerClassName='h-screen' />;

  return (
    <div id="taxSetupPageContainer">
      <PageHeader id="taxSetupPageHeader">
        <Heading variant='h3' title={`Tax Setup`} id="taxSetupPageTitle" />
        <Heading
          variant='body-s'
          title={`View all tax data in your company.`}
          color={`${COLORS.Gray}`}
          id="taxSetupPageDescription"
        />
      </PageHeader>

      {/* <Table
        columns={TaxSetupHeader(actions)}
        data={taxList?.items ?? []}
        loading={status}
        showPagination
        totalCounts={taxList?.totalCount ?? 10}
        tableInfo={tableInfo}
        setTableInfo={setTableInfo}
        showCheckBox={true}
        onChecked={handleChecked}
        checkedValues={checkedValues}
        showBulkExport={true}
        handleExportBulk={() => {
          handleBulkExport(checkedValues);
        }}
        alwaysOnDisplay={true}
      /> */}
      <DynamicTable
        schema={schema}
        data={data}
        totalCounts={taxList?.totalCount ?? 10}
        loading={status}
        templateDatas={TemplateDatas}
        showCheckBox={true}
        filteredKey='id'
        // showBulkExport={checkedValues?.length > 0}
        showBulkExport={true} //used true instead of checkedValues?.length > 0 to show bulk export button always by default without selecting any checkbox
        handleExportBulk={() => handleBulkExport(checkedValues)}
        onChecked={handleChecked}
        checkedValues={checkedValues}
        components={{
          renderRightToolbarButton,
        }}
        tableColumnList={tableHeaderList}
        selectedColumnList={headerList}
        tablePreferenceLoading={tablePrefLoading}
        handleColumnSave={handleSavePreference}
        id="taxSetupTable"
      />
      <AnimationWrapper>
        {isModalOpen && (
          <TaxSetupModal
            id="taxSetupModal"
            isModalOpen={isModalOpen}
            closeModal={() => {
              closeModal();
              setInitialValue(null);
              setModalStatus('Add');
            }}
            modalStatus={modalStatus}
            setModalStatus={setModalStatus}
            initialValue={initialValue}
            loading={isLoading}
          />
        )}
      </AnimationWrapper>
      <AnimationWrapper>
        {isRequestModalOpen && (
          <RequestModal
            isShow={isRequestModalOpen}
            closeModal={() => {
              closeRequestModal();
              setModalStatus('Add');
            }}
            modalStatus={modalStatus}
            title={`${modalStatus === 'Delete'
              ? 'delete this tax setup'
              : modalStatus === 'Deactivate'
                ? 'deactivate this tax setup'
                : modalStatus === 'Activate'
                  ? 'activate this tax setup'
                  : ''
              }`}
            setRemark={setRemark}
            remark={remark}
            handleSubmit={onRequest}
            loading={loading}
            dataRow={dataRow}
          />
        )}
      </AnimationWrapper>
      <AnimationWrapper>
        {isModalOpenOverrideTax && (
          <TaxOverrideModal
            isModalOpen={isModalOpenOverrideTax}
            closeModal={() => {
              setInitialValue(null);
              closeModalOverrideTax();
            }}
            modalStatus={modalStatus}
            setModalStatus={setModalStatus}
            initialValue={initialValue}
          />
        )}
      </AnimationWrapper>

      <AnimationWrapper>
        {isOpenImport && (
          <TaxImportModal
            isModalOpen={isOpenImport}
            fileImport={fileImport}
            handleSubmit={handleSubmit}
            closeModal={() => {
              closeImport();
              setImportFile(null);
              setCalculatedData(null);
            }}
            error={apiError}
            isLoading={fileUploadLoader}
            data={calculatedData}
            importedFileName={importedFile?.name}
          />
        )}
      </AnimationWrapper>
    </div>
  );
};

export default withDynamicTableContext(TaxSetup, false, axiosInstance);
